import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const rows = [{
  topic: 'Setup Técnico',
  without: 'Semanas configurando sin saber si está bien',
  with: 'Ecosistema listo en 48hs'
}, {
  topic: 'Productos',
  without: 'Sin saber qué producto digital vender',
  with: '100 productos validados listos para subir'
}, {
  topic: 'Metodología Ads',
  without: 'Gastando en ads sin metodología',
  with: 'Testeo estructurado desde el día 1'
}, {
  topic: 'Aprendizaje',
  without: 'Tutoriales contradictorios de YouTube',
  with: 'Sistema en orden lógico paso a paso'
}, {
  topic: 'Tracking',
  without: 'Sin pixel instalado correctamente',
  with: 'Pixel activo desde el inicio'
}, {
  topic: 'Posicionamiento',
  without: 'Sin diferenciarte en el mercado',
  with: 'Método De Genérico a Ganador aplicado'
}, {
  topic: 'Creativos',
  without: 'Sin saber qué anuncio crear',
  with: 'Biblioteca de creativos ganadores'
}, {
  topic: 'Resultados',
  without: 'Meses sin tu primera venta real',
  with: 'Negocio listo para vender este finde'
}];
export function Comparison() {
  return <section className="py-12 md:py-20 relative" data-id="element-33">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-34">
        <div className="text-center mb-8 md:mb-12" data-id="element-35">
          <h2 className="text-gold-500 font-display text-base md:text-2xl tracking-widest uppercase mb-2 md:mb-3" data-id="element-36">
            La Realidad
          </h2>
          <p className="text-2xl md:text-5xl font-display text-white uppercase tracking-wide leading-tight" data-id="element-37">
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-800/50 rounded-2xl border border-white/10 overflow-hidden shadow-[0_0_40px_rgba(212,175,55,0.08)]" data-id="element-38">
          {/* Header */}
          <div className="grid grid-cols-[80px_1fr_1fr] md:grid-cols-[200px_1fr_1fr] bg-dark-900/80 border-b border-white/10" data-id="element-39">
            <div className="p-2.5 md:p-4" data-id="element-40" />
            <div className="p-2.5 md:p-4 border-l border-white/10 text-center bg-red-950/20" data-id="element-41">
              <div className="font-display text-xs md:text-base uppercase tracking-wider text-red-400" data-id="element-42">
                Sin Sistema
              </div>
            </div>
            <div className="p-2.5 md:p-4 border-l border-gold-500/20 text-center bg-gold-500/10" data-id="element-43">
              <div className="font-display text-xs md:text-base uppercase tracking-wider text-gold-400" data-id="element-44">
                Con Sistema
              </div>
            </div>
          </div>

          {/* Rows */}
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className={`grid grid-cols-[80px_1fr_1fr] md:grid-cols-[200px_1fr_1fr] ${i % 2 === 0 ? 'bg-dark-900/30' : 'bg-transparent'} border-b border-white/5 last:border-b-0`} data-id="element-45">
              <div className="p-2.5 md:p-4 flex items-center" data-id="element-46">
                <div className="text-[10px] md:text-sm font-bold text-gold-500/80 uppercase tracking-wider leading-tight" data-id="element-47">
                  {row.topic}
                </div>
              </div>
              <div className="p-2.5 md:p-4 border-l border-white/5 flex items-start gap-2" data-id="element-48">
                <div className="mt-0.5 md:mt-1 bg-red-900/20 rounded-full p-0.5 md:p-1 shrink-0" data-id="element-49">
                  <XIcon className="text-red-500 w-2.5 h-2.5 md:w-3 md:h-3" data-id="element-50" />
                </div>
                <span className="text-gray-400 text-[11px] md:text-sm leading-snug" data-id="element-51">
                  {row.without}
                </span>
              </div>
              <div className="p-2.5 md:p-4 border-l border-gold-500/10 flex items-start gap-2 bg-gold-500/[0.02]" data-id="element-52">
                <div className="mt-0.5 md:mt-1 bg-gold-500/20 rounded-full p-0.5 md:p-1 shrink-0" data-id="element-53">
                  <CheckIcon className="text-gold-500 w-2.5 h-2.5 md:w-3 md:h-3" data-id="element-54" />
                </div>
                <span className="text-white text-[11px] md:text-sm font-medium leading-snug" data-id="element-55">
                  {row.with}
                </span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}